<template>
  <div class="table-pivot-config">
    <div v-if="internalPivotConfig" class="groups">
      <!-- AJUSTAR LOS "pivot-config-groups" para qeu "hagan": Dimensio visualizada vs altres dimensions
      
      el truco esta en que "no hay role=columns" seteable, pero se setea "en el get/Set" del internal value! -->
      <!-- {{ pivotConfig }} -->
      <pivot-config-group
        v-model="internalPivotConfig"
        :options="flatDimensionsOptions"
        :metas="dimensionMetas"
        role="chart"
        :chart-type="chartType"
        :max-items="maxChartDims"
      />
      <!-- <pivot-config-group
        v-model="internalPivotConfig.dimensions"
        :options="flatDimensionsOptions"
        :metas="dimensionMetas"
        role="columns"
      /> -->
      <pivot-config-group
        v-model="internalPivotConfig"
        :options="flatDimensionsOptions"
        :metas="dimensionMetas"
        :chart-type="chartType"
        role="filters"
      />
    </div>
  </div>
</template>

<script>
import PivotConfigGroup from './PivotConfigGroup.vue'
import chartUtils from '@/utils/chart'
export default {
  components: { PivotConfigGroup },
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: ['pivotConfig', 'flatDimensionsOptions', 'dimensionMetas', 'chartType'],
  data() {
    return {
      internalPivotConfig: null,
    }
  },
  computed: {
    maxChartDims() {
      return chartUtils[this.chartType].maxChartDims
    },
  },
  watch: {
    // AQUI VA LA "burjeria" para los "stacked/grouped"
    // Que son, row columns con multivalues
    // sino, da igual CUAL es el que esta a row columns en verdad...
    pivotConfig: {
      handler(value) {
        this.internalPivotConfig = JSON.parse(JSON.stringify(value))
        let colDims = this.internalPivotConfig.dimensions.filter(dim => dim.role === 'columns')
        let rowDims = this.internalPivotConfig.dimensions.filter(dim => dim.role === 'rows')
        rowDims.forEach(dim => {
          dim.role = 'chart'
        })
        colDims.forEach(dim => {
          //Disableing "move to filters" cuando solo tiene un value
          // if (dim.values.length === 1) dim.role = 'filters'
          // else dim.role = 'chart'
          dim.role = 'chart'
        })
      },
      immediate: true,
    },
    internalPivotConfig: {
      handler(value) {
        let out = JSON.parse(JSON.stringify(value))
        let chartDims = out.dimensions.filter(d => d.role === 'chart')
        let maxRowDims = chartUtils[this.chartType].maxRowDims
        chartDims.forEach((dim, i) => {
          if (i < maxRowDims) dim.role = 'rows'
          else dim.role = 'columns'
        })
        if (JSON.stringify(out) !== JSON.stringify(this.pivotConfig)) {
          this.$emit('change', out)
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="stylus" scoped></style>
